<template>
  <div class="contact">
    <div class="container phx20">
      <h1>{{ $t('cities.contact.heading') }}</h1>
    </div>
    <div class="container phx20 flex-l flex-row-reverse">
      <div class="w-50-l tl-l pa4 pb0 pt5-l">
        <img
          class="dib v-mid logo-main mt4 mb3"
          src="~/assets/images/logo-discontract-multi.svg"
          width="126"
          height="30"
          alt="Discontract logo"
        />
        <p class="f4 fw5">UAB „Virtualioji darbo rinka“</p>
        <!-- <p class="fw5">{{ $t('cities.contact.phone') }}</p>
        <p>
          <a class="pointer" @click.stop="callSupport()">{{ supportNumber }}</a>
        </p> -->
        <p class="fw5">{{ $t('cities.contact.email') }}</p>
        <p><a href="mailto:info@discontract.com">info@discontract.com</a></p>
        <p class="">{{ $t('cities.contact.address') }}</p>
        <p v-if="$i18n.locale.split('-')[1] === 'PL'">
          ul. Mokotowska 57 apt. 9, 00-542 Warszawa
        </p>
        <p v-else>Laisvės pr. 60-1107, LT-05120 Vilnius</p>
      </div>
      <div class="w-50-l">
        <div class="aspect-ratio aspect-ratio--1x1">
          <iframe
            v-if="$i18n.locale.split('-')[1] === 'PL'"
            class="aspect-ratio--object"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.9903690577103!2d21.019249315593033!3d52.225392779759495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471eccf00840abd3%3A0xd96a23b2c84720ad!2sMokotowska%2057%2C%2000-542%20Warszawa!5e0!3m2!1spl!2spl!4v1618570602767!5m2!1spl!2spl"
            width="600"
            height="450"
            frameborder="0"
            style="border: 0"
            allowfullscreen=""
          ></iframe>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2305.0960263727256!2d25.22515951548975!3d54.70793367955327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46dd931e93829e49%3A0x1fee86bc56aa339b!2sLaisv%C4%97s%20pr.%2060%2C%20Vilnius%2005103!5e0!3m2!1slt!2slt!4v1643018231760!5m2!1slt!2slt"
            width="600"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import events from '~/constants/events';

export default {
  name: 'Contact',
  scrollToTop: true,
  data() {
    return {
      supportNumber: '',
    };
  },
  computed: {
    events() {
      return events;
    },
  },
  methods: {
    async callSupport() {
      // extracted to a method so that bi event would pass
      await this.$analytics.trackEvent(events.PRESS_SUPPORT_CALL);
      const newWnd = window.open('tel:' + this.supportNumber, '_self');
      newWnd.opener = null;
    },
  },
  head() {
    return {
      title: this.$t('contact.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('contact.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('contact.description'),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('contact.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
